module.exports = __webpack_public_path__ + "img/home-banner-3d-en.0bd5449d.jpg";